import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { FilterDefinitionItem } from '../../../core/model/filter-definition-item';
import { PagedObjectManagerComponent } from '../../../core/component/paged-object-manager/paged-object-manager';
import { ColumnDefinitionService } from '../../../rent/service/data/column-definition.service';
import { PriceList } from '../../model/pricelist';
import { PriceListService } from '../../service/pricelist.service';
import { PriceListCommandHandlerResolver } from '../../service/command/pricelist-command-handler-resolver.service';
import { MeterMediaTypeSelection } from '../../model/const/enums';

@Component({
    selector: 'app-imd-pricelist-manager',
    templateUrl: './../../../core/component/paged-object-manager/paged-object-manager.html',
    styleUrls: ['./../../../core/component/paged-object-manager/paged-object-manager.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImdPriceListManagerComponent extends PagedObjectManagerComponent<PriceList> {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    private _dataService: PriceListService,
    dispatcher: CommandDispatcher,
    handlerResolver: PriceListCommandHandlerResolver,
    messageService: MessageService,
    navigationService: NavigationService
  ) {
    super(_dataService, messageService, navigationService, dispatcher, handlerResolver);
    this.columnDefinition = columnDefinitionService.getImdPriceListColumnDefinition(this);
    this.title = 'CONSUMPTION.PRICELIST.PRICELISTS';
    this.preferencesKey = 'consumption.pricelist.list';
  }

  ngOnInit() {
    this.AddSubscription(
      this._dataService.getFilterDefinition().subscribe(definition => {
        this.defaultFilters = definition.defaultFields;
        let meterTypeSelection = MeterMediaTypeSelection.map(v => {
          return { caption: v.name, value: v.value };
        });
        meterTypeSelection.splice(0, 0, { caption: 'ALL_TEXT', value: null });
        this.filterDefinition = [
          new FilterDefinitionItem('CONSUMPTION.PRICELIST.NAME', 'name', definition.name, null, definition.selectedFields.includes('name')),
          new FilterDefinitionItem(
            'CONSUMPTION.MEDIA_TYPE.TYPE',
            'meterType',
            definition.meterType,
            meterTypeSelection,
            definition.selectedFields.includes('meterType')
          ),
        ];
      })
    );

    this.addEditDeleteCommands();
  }
}
